/* TODO: t() */
import React from 'react';

import { Table, Tbody, Td, Th, Thead, Tr } from '../../core-ui';
import { VendorPlacementByIndex } from '../../types/shared/Placement';

type Props = {
  numSpots: number;
  onClick: (index: number) => void;
  vendorPlacement: VendorPlacementByIndex;
};

export function VendorPlacementList(props: Props) {
  const { numSpots, onClick, vendorPlacement } = props;

  // Make an array from 0 to the number of spots - 1;
  const spotsArray = Array.from({ length: numSpots }).map((_, i) => i);

  return (
    <Table width="full">
      <Thead>
        <Tr>
          <Th>Spot number</Th>
          <Th>Name</Th>
        </Tr>
      </Thead>
      <Tbody>
        {spotsArray.map((spotNumber) => (
          <Tr
            key={spotNumber}
            _hover={{ backgroundColor: 'gray.50' }}
            cursor="pointer"
            onClick={() => {
              onClick(spotNumber);
            }}
          >
            <Td
              sx={{
                maxWidth: 300,
                overflow: 'hidden',
                overflowWrap: 'break-word',
              }}
            >
              {spotNumber}
            </Td>
            <Td
              sx={{
                maxWidth: 300,
                overflow: 'hidden',
                overflowWrap: 'break-word',
              }}
            >
              {vendorPlacement[spotNumber]?.name ?? ''}
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
